import React, { useEffect, useState, useContext } from "react";

import * as S from "./Estilos";

import Android from "../../Images/android.png";
import Apple from "../../Images/apple.png";
import Logo from "../../Images/logo.png";

function Home(props) {
  return (
    <S.Container>
      <S.Wrapper>
        <img src={Logo} style={{ width: "350px" }}></img>
      </S.Wrapper>

      <S.Wrapper  style={{ cursor: "pointer" }}
        onClick={() => {
          window.open("https://play.google.com/store/apps/details?id=com.recplayapp");
        }}>
        
        <img src={Android} style={{ width: "350px" }}></img>
      </S.Wrapper>
      <S.Wrapper
        style={{ cursor: "pointer" }}
        onClick={() => {
          window.open("https://apps.apple.com/us/app/reclame/id1620198874");
        }}
      >
        <img src={Apple} style={{ width: "350px" }}></img>
      </S.Wrapper>
    </S.Container>
  );
}

export default Home;
